module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[34]399.b0bbc47.woff2";